import { render, staticRenderFns } from "./ClosePpaAction.vue?vue&type=template&id=33ace9cd&scoped=true"
import script from "./ClosePpaAction.vue?vue&type=script&lang=js"
export * from "./ClosePpaAction.vue?vue&type=script&lang=js"
import "./ClosePpaAction.vue?vue&type=style&index=0&id=33ace9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ace9cd",
  null
  
)

export default component.exports